class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
    if (this.isHoverEnabled()) {
      this.initHoverHandlers();
    }
  }

  isHoverEnabled() {
    return this.classList.contains('is-hover-cart');
  }

  setHeaderCartIconAccessibility() {
    if (this.hasCartIconClickListener) return;
    this.hasCartIconClickListener = true;

    document.addEventListener('click', (event) => {
      const cartBubble = event.target.closest('#cart-icon-bubble');
      if (!cartBubble) return;

      const isCartPage = window.location.pathname.endsWith('/cart') || document.body.classList.contains('template-cart');
      if (isCartPage) return;

      if (window.innerWidth >= 1200 && this.isHoverEnabled()) {
        event.preventDefault();
        event.stopImmediatePropagation();

        let targetUrl = cartBubble.getAttribute('href');
        if (!targetUrl || targetUrl === '#' || targetUrl.startsWith('javascript:')) {
          targetUrl = (window.routes && window.routes.cart_url) || '/cart';
        }

        window.location.href = targetUrl;
      } else {
        event.preventDefault();
        if (this.classList.contains('active')) {
          this.close();
        } else {
          this.open(cartBubble);
        }
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        const cartBubble = event.target.closest('#cart-icon-bubble');
        if (cartBubble) {
          event.preventDefault();
          this.open(cartBubble);
        }
      }
    });
  }

  initHoverHandlers(){
    if (!this.isHoverEnabled()) return;

    const isCartPage = window.location.pathname.endsWith('/cart') || document.body.classList.contains('template-cart');
    if (isCartPage) return;

    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const openDropdown = () => {
      if (window.innerWidth < 1200 || !this.isHoverEnabled()) return;
      clearTimeout(this.hoverTimeout);
      this.open(cartLink);
    };

    const closeDropdownWithDelay = (e) => {
      if (window.innerWidth < 1200 || !this.isHoverEnabled()) return;
      const drawerInner = this.querySelector('.drawer__inner');
      const related = e && e.relatedTarget;
      if (related && (cartLink.contains(related) || (drawerInner && drawerInner.contains(related)))) {
        return;
      }
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.close();
      }, 150);
    };

    cartLink.addEventListener('mouseenter', openDropdown);
    cartLink.addEventListener('mouseleave', closeDropdownWithDelay);

    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) {
      drawerInner.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 1200 && this.isHoverEnabled()) {
          clearTimeout(this.hoverTimeout);
        }
      });
      drawerInner.addEventListener('mouseleave', closeDropdownWithDelay);
    }

    window.addEventListener('resize', () => {
      if (this.classList.contains('active') && this.isHoverEnabled()) {
        this.positionDropdown();
      }
    });
    window.addEventListener('scroll', () => {
      if (this.classList.contains('active') && this.isHoverEnabled()) {
        this.positionDropdown();
      }
    });
  }
  positionDropdown(){
    if(window.innerWidth < 1200 || !this.isHoverEnabled()){
      this.style.position = '';
      this.style.top = '';
      this.style.left = '';
      this.style.right = '';
      this.style.height = '';
      return;
    }

    const cartLink = document.querySelector('#cart-icon-bubble');
    if(!cartLink) return;

    const rect = cartLink.getBoundingClientRect();
    const screenWidth = document.documentElement.clientWidth;
    this.style.position = 'fixed';
    this.style.top = `${rect.bottom - 1}px`;
    this.style.right = `${screenWidth - rect.right}px`;
    this.style.left = 'auto';
    this.style.height = 'auto';
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    if (window.innerWidth >= 1200 && this.isHoverEnabled()) {
      document.body.classList.add('mini-cart-open');
      this.positionDropdown();
    }
    
    this.classList.add('animate', 'active');

    if (window.innerWidth < 1200 || !this.isHoverEnabled()) {
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
     this.classList.remove('active');
    try {
      if (this.activeElement) {
        removeTrapFocus(this.activeElement);
      } else {
        removeTrapFocus();
      }
    } catch (e) {}

    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink && document.activeElement === cartLink) {
      cartLink.blur();
    }
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('mini-cart-open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.setHeaderCartIconAccessibility();
    if (this.isHoverEnabled()) {
      this.initHoverHandlers();
    }
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      const isCartPage = window.location.pathname.endsWith('/cart') || document.body.classList.contains('template-cart');
      if (!isCartPage) {
        this.open();
      } else {
        window.location.reload();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
